import InboxService from '@/services/InboxService';

let interval = null;
let currentParams = null;

const state = {
  data: {},
  loading: false,
  error: null,
};

const mutations = {
  SET_DATA(state, payload) {
    state.data = payload;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchAccountRegister({ commit }, params) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const data = await InboxService.getAccountRegister(params);
      commit('SET_DATA', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  initAccountRegisterPolling({ dispatch }, params) {
    currentParams = params;
    dispatch('fetchAccountRegister', currentParams);

    if (!interval) {
      interval = setInterval(() => {
        if (document.hidden) return;
        if (currentParams) {
          dispatch('fetchAccountRegister', currentParams);
        }
      }, 30000); // Poll every 30 seconds
    }
  },

  stopAccountRegisterPolling() {
    if (interval) {
      clearInterval(interval);
      interval = null;
      currentParams = null;
    }
  },
};

const getters = {
  getAccountRegisterData: (state) => state.data,
  isLoading: (state) => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
